import React, { useState, useEffect } from "react";
import axios from "../../../../../utils/axios";
import CustomDropdown from "../../../../utilities/CustomDropdown";

const AssignCustomer = (props) => {
  const [deviceList, setDeviceList] = useState([]);

  const getList = async () => {
    try {
      const viewDeviceList = await axios.post("view/device/list");
      setDeviceList(viewDeviceList?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  useEffect(() => {
    (async () => {
      if (props.customerId && props.device) {
        try {
          await axios.post("assign/customer", {
            deviceId: props.device,
            customerId: props.customerId,
          });
        } catch (error) {
          console.log(error);
        }
      }
    })();
  }, [props.customerId, props.device]);

  const filteredData = deviceList.filter((item) => item.customer_id === null);

  // Format filtered data for CustomDropdown
  const formattedDevices = filteredData.map((item) => ({
    id: item.id,
    name: item.alias_name,
  }));

  return (
    Array.isArray(filteredData) &&
    filteredData?.length !== 0 && (
      <div>
        <CustomDropdown
          label="Add Device"
          items={formattedDevices}
          value={props.value}
          onSelect={props.onChange}
          searchPlaceholder="Select Device..."
          showId={false}
          required={false}
        />
      </div>
    )
  );
};

export default AssignCustomer;
